module.exports = __webpack_public_path__ + "img/Sama-Logo.90c0e96d.svg";